import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {App} from 'ionic-angular';
import {OauthService} from './oauth.service';
import {SondageReponse} from '../models/sondage/sondageReponse.model';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class SondageReponseService extends OauthService {

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
  }

  vote(sondageReponse: SondageReponse) {
    const url = this.Routing.generate('api_post_sondage-reponses', {'_format': 'json'}, true);
    return this.http
      .post(url, JSON.stringify(sondageReponse), {headers: this.updateHeaders()});
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/sondageReponse.service.ts